import 'bootstrap';
import ready, { HTML } from './utils';
import initMenu from './components/menu';
import initAccordion from './components/accordion';
import initSwiper from './components/swiper';
import initDatepicker from './components/datePicker';
import initScripts from './components/script';

ready(() => {
  HTML.classList.add('is-loaded');
  initMenu();
  initSwiper();
  initAccordion();
  initScripts();
  initDatepicker();
});
